import * as actionTypes from './actions'
import auth from '../modules/auth'
import { subscribeChatroomChannel } from '../websocket'
// ACTION CREATORS
export const actions = {
  onReceivedFromChatroomChannel: (data) => {
    return {
      type: actionTypes.ON_RECEIVED_FROM_CHAT_ROOM_CHANNEL,
      payload: data
    }
  },
  fetchChatrooms: () => {
    return {
      type: actionTypes.SAVE_FETCHED_CHAT_ROOMS_TO_STORE_REQUEST
    }
  },
  fetchMessages: (chatroomId) => {
    return {
      type: actionTypes.SAVE_FETCHED_MESSAGES_TO_STORE_REQUEST,
      chatroomId
    }
  },
  updateTypingMessage: (message, chatroomId) => {
    return {
      type: actionTypes.UPDATE_TYPING_MESSAGE,
      payload: {
        message,
        chatroomId
      }
    }
  },
  toggleShowSupportChatRoom: () => {
    return {
      type: actionTypes.TOGGLE_SHOW_SUPPORT_CHAT_ROOM
    }
  },
  loadMoreMessages: (chatroomId, from) => {
    return {
      type: actionTypes.LOAD_MORE_MESSAGES_REQUEST,
      payload: {
        chatroomId,
        from
      }
    }
  },
  setShowingChatroomId: (chatroomId) => {
    return {
      type: actionTypes.SET_SHOWING_CHATROOM_ID,
      chatroomId: chatroomId
    }
  }
}

// REDUCERS
// initialState format
// const initialState = {
//   chatrooms: {
//     chatroomId: {
//       id: null,
//       findme_doctor_proposal_id: null,
//       currentChatroomMemberId: null,
//       findme_messages: [],
//       typing_message: "",
//       reachedLastMessage: false,
//     }
//   },
//   showFloatingSupportChatRoom: false
// }
const initialState = {
  chatrooms: {},
  showFloatingSupportChatRoom: false,
  showingChatroomId: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ON_RECEIVED_FROM_CHAT_ROOM_CHANNEL:
      return onReceivedFromChatroomChannel(state, action)
    case actionTypes.SAVE_FETCHED_CHAT_ROOMS_TO_STORE:
      return saveFetchedChatroomsToStore(state, action)
    case actionTypes.SAVE_FETCHED_MESSAGES_TO_STORE:
      return saveFetchedMessagesToStore(state, action)
    case actionTypes.UPDATE_TYPING_MESSAGE:
      return updateTypingMessage(state, action)
    case actionTypes.TOGGLE_SHOW_SUPPORT_CHAT_ROOM:
      return toggleShowSupportChatRoom(state)
    case actionTypes.SAVE_LOADED_MESSAGES_TO_STORE:
      return saveLoadedMessagesToStore(state, action)
    case actionTypes.SET_SHOWING_CHATROOM_ID:
      return setShowingChatroomId(state, action)
    case actionTypes.NOTIFICATION_NEW_CHATROOM:
      return notificationNewChatroom(state, action)
    default:
      return state
  }
}

const notificationNewChatroom = (state, action) => {
  const newChatroom = reformatChatroom(action.payload.chatroom)

  subscribeChatroomChannel([newChatroom.id])

  return {
    ...state,
    chatrooms: {
      ...state.chatrooms,
      [newChatroom.id]: newChatroom
    }
  }
}

const saveLoadedMessagesToStore = (state, action) => {
  const { chatroomId, messages } = action.payload
  const newMessages = [...messages, ...state.chatrooms[chatroomId].findme_messages]
  const chatroom = {
    ...state.chatrooms[chatroomId],
    findme_messages: newMessages,
    reachedLastMessage: messages.length < 30,
  }
  return {
    ...state,
    chatrooms: {
      ...state.chatrooms,
      [chatroomId]: chatroom
    }
  }
}

const setShowingChatroomId = (state, action) => {
  return {
    ...state,
    showingChatroomId: action.chatroomId
  }
}

const toggleShowSupportChatRoom = (state) => {
  return {
    ...state,
    showFloatingSupportChatRoom: !state.showFloatingSupportChatRoom
  }
}

const updateTypingMessage = (state, action) => {
  let {message} = action.payload
  if (message.replace(/^[\n]+|[\n]+$/g, '').length === 0) {
    message = ''
  }
  const chatroom = {
    ...state.chatrooms[action.payload.chatroomId],
    typing_message: message
  }
  return {
    ...state,
    chatrooms: {
      ...state.chatrooms,
      [action.payload.chatroomId]: chatroom
    }
  }
}

const saveFetchedMessagesToStore = (state, action) => {
  const { messages } = action.payload
  const chatroomId = action.payload.chatroomId
  const chatroom = {
    ...state.chatrooms[chatroomId],
    findme_messages: messages,
    reachedLastMessage: messages.length < 30
  }
  return {
    ...state,
    chatrooms: {
      ...state.chatrooms,
      [chatroomId]: chatroom
    }
  }
}

const saveFetchedChatroomsToStore = (state, action) => {
  const chatrooms = action.payload.reduce((results, chatroom) => {
    results[chatroom.id] = reformatChatroom(chatroom)
    return results
  }, {})
  return {
    ...state,
    chatrooms: {
      ...chatrooms
    }
  }
}

const onReceivedFromChatroomChannel = (state, action) => {
  switch (action.payload.action) {
    case "new_message":
      return addNewMessage(state, action.payload.message)
    default:
      return state
  }
}

const addNewMessage = (state, message) => {
  const chatroomId = message.findme_chatroom_id
  const chatroom = state.chatrooms[chatroomId]
  if (!chatroom) {
    return {
      ...state
    }
  }
  const currentMessages = chatroom.findme_messages || []
  const newMessages = currentMessages.slice()
  newMessages.push(message)

  const newChatroom = {
    ...chatroom,
    findme_messages: newMessages
  }

  return {
    ...state,
    chatrooms: {
      ...state.chatrooms,
      [chatroomId]: newChatroom
    }
  }
}

const reformatChatroom = (chatroom) => {
  let reformattedChatroom = {...chatroom}

  let currentMember = null
  let otherMembers = []

  chatroom.findme_chatroom_members.forEach(fcm => {
    if (fcm.member_type === "findme_customer" && fcm.member_id === auth.getCustomerInfoBy('id')) {
      currentMember = fcm
    } else {
      otherMembers.push(fcm)
    }
  })

  const chatroomAvatar = otherMembers.length ? otherMembers[0].member_avatar : null
  const chatroomName = otherMembers.length ? otherMembers[0].member_name : null
  reformattedChatroom.currentChatroomMemberId = currentMember.id
  reformattedChatroom.name = chatroomName
  reformattedChatroom.avatar = chatroomAvatar
  reformattedChatroom.reachedLastMessage = false
  return reformattedChatroom
}



// WEBPACK FOOTER //
// ./src/modules/chat.js